import { render, staticRenderFns } from "./wendujilu.vue?vue&type=template&id=b6f91172&scoped=true"
import script from "./wendujilu.vue?vue&type=script&lang=js"
export * from "./wendujilu.vue?vue&type=script&lang=js"
import style0 from "./wendujilu.vue?vue&type=style&index=0&id=b6f91172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f91172",
  null
  
)

export default component.exports